// Get Tracked Serials Use Case

import {InventoryRepository} from '../repository/InventoryRepository';
import {TrackedSerial} from '../models/inventory.model';

export class GetTrackedSerialsUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (filters?: {
    productId?: string;
    locationId?: string;
    status?: string;
    page?: number;
    limit?: number;
    search?: string;
  }): Promise<{ items: TrackedSerial[]; pagination?: any }> {
    try {

      const result = await this.inventoryRepository.getTrackedSerials(filters);

      // Business Logic: Sort by most recent first, group available serials at top
      const sortedSerials = result.items.sort((a, b) => {
        // Available status first
        if (a.status === 'AVAILABLE' && b.status !== 'AVAILABLE') {return -1;}
        if (a.status !== 'AVAILABLE' && b.status === 'AVAILABLE') {return 1;}

        // Then by creation date (most recent first)
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      });

      return {
        items: sortedSerials,
        pagination: result.pagination
      };
    } catch (error) {
      throw error;
    }
  }
}
